import type { AuthenticationCreateRequest, AuthenticationResponse } from '../types';
import type { RequestFn } from '../client';

export class Authentication {
  constructor(private readonly request: RequestFn) {}

  async create(params: AuthenticationCreateRequest): Promise<AuthenticationResponse> {
    return this.request('POST', '/authentication', { body: params });
  }

  async checkEligibility(authId: string): Promise<AuthenticationResponse> {
    return this.request('POST', `/authentication/${encodeURIComponent(authId)}/eligibility`);
  }

  async authenticate(
    authId: string,
    params: Record<string, unknown>,
  ): Promise<AuthenticationResponse> {
    return this.request('POST', `/authentication/${encodeURIComponent(authId)}/authenticate`, {
      body: params,
    });
  }

  /** Sync authentication status. `POST /authentication/{merchantId}/{authId}/sync` */
  async sync(
    merchantId: string,
    authId: string,
    params?: Record<string, unknown>,
  ): Promise<AuthenticationResponse> {
    return this.request(
      'POST',
      `/authentication/${encodeURIComponent(merchantId)}/${encodeURIComponent(authId)}/sync`,
      { body: params },
    );
  }

  /** Redirect after authentication. `POST /authentication/{merchantId}/{authId}/redirect` */
  async redirect(
    merchantId: string,
    authId: string,
    params: Record<string, unknown>,
  ): Promise<Record<string, unknown>> {
    return this.request(
      'POST',
      `/authentication/${encodeURIComponent(merchantId)}/${encodeURIComponent(authId)}/redirect`,
      { body: params },
    );
  }

  /** Enable authn methods token. `POST /authentication/{authId}/enabled-authn-methods-token` */
  async enabledAuthnMethodsToken(
    authId: string,
    params: Record<string, unknown>,
  ): Promise<Record<string, unknown>> {
    return this.request(
      'POST',
      `/authentication/${encodeURIComponent(authId)}/enabled-authn-methods-token`,
      {
        body: params,
      },
    );
  }

  /** Submit eligibility check. `POST /authentication/{authId}/eligibility-check` */
  async eligibilityCheck(
    authId: string,
    params: Record<string, unknown>,
  ): Promise<Record<string, unknown>> {
    return this.request('POST', `/authentication/${encodeURIComponent(authId)}/eligibility-check`, {
      body: params,
    });
  }
}
